module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r6r5n1n-a486c46e45d5291ce04c70f5d1c4ea4d.svg";